import { KeyValue } from '@angular/common';

export interface FeedbackRequest {
  rating?: number;
  comment?: string;
  hasTechnicalIssues?: string;
  technicalIssue?: string;
}

export interface FeedbackError {
  errorTitle: string;
  errorMessage: string;
}

export interface FeedbackMessage {
  feedbackTitle?: string;
  feedbackMessage?: string;
}

export const FeedbackRating: KeyValue<number, string>[] = [
  { key: 1, value: 'Very difficult' },
  { key: 2, value: 'Difficult' },
  { key: 3, value: 'Neutral' },
  { key: 4, value: 'Easy' },
  { key: 5, value: 'Very easy' },
];
